export const Z_INDEX = {
  progressBar: 1003,
  header: 1002,
  mapOverlay: 1001,
  // 1000 enforced by leaflet
};
